import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import StudentForm from './StudentForm';
import StudentFormService from '../services/StudentFormService';
import Async from '../../../core/layout/Async';

class StudentFormContainer extends Component {
  static propTypes = {
    studentId: PropTypes.string,
    schoolId: PropTypes.string,
    classId: PropTypes.string,
    academicPlanId: PropTypes.string,
    locale: PropTypes.string,
  };

  static defaultProps = {
    studentId: null,
    schoolId: null,
    classId: null,
    academicPlanId: null,
    locale: null,
  };

  studentFormService = new StudentFormService();
  componentWillMount() {
    this.studentFormService.handleLoad(
      this.props.studentId,
      this.props.schoolId,
      this.props.classId,
      this.props.academicPlanId,
      this.props.locale
    );
  }

  render() {
    return (
      <Async fetching={this.studentFormService.fetch.fetching}>
        <StudentForm
          onSubmit={this.studentFormService.handleSubmit}
          onChange={this.studentFormService.form.setValue}
          onReset={this.studentFormService.form.reset}
          values={this.studentFormService.form.getValues()}
          errors={this.studentFormService.form.errors}
          submitting={this.studentFormService.submit.fetching}
          isDirty={this.studentFormService.form.isDirty}
        />
      </Async>
    );
  }
}

export default observer(StudentFormContainer);
